import { useFetchBuilderSession } from './useFetchBuilderSession'
import { createQueryComposable } from '../session/queryComposableFactory'

export const useQueryBuilderSession = createQueryComposable(useFetchBuilderSession)
